import { appData, getApiKey } from 'optinmonster-js-library/src/utils';
import { disableDevCookie } from 'optinmonster-js-library/src/utils/apiKey';
import state from './state';
import { dismissKeys } from '../dashboard/store/state';

disableDevCookie();

const templatePaths = [
	'templates.activeType',
	// 'templates.activeTemplate',
	// 'templates.sort',
	// 'templates.search',
	'templates.filterOptions',
	// 'templates.filters',
];

// `plugins` is deliberately not persisted: each entry carries a short-lived `actionNonce`
// used to authorize installs, and WP nonces only live 12-24h and are tied to the login
// session. Persisting the list meant a token cached days earlier was replayed on the next
// install, which the server rejected with "Security token invalid!" (#944). Every consumer
// of this list already fetches it on mount, so it costs nothing to refetch.
//
// Note this does not clean up browsers that already stored it: vuex-persistedstate merges the
// whole saved blob back into state on init and only applies `paths` when writing, so an
// existing visitor rehydrates their old `plugins` (stale nonce included) until the next save
// overwrites it. That is safe only because App.vue always refetches before installing — keep
// that refetch even if this list looks like it can no longer hold a nonce.
const persistedPaths = ['visits'];
dismissKeys.forEach((k) => {
	persistedPaths.push(`dashboard.${k}`);
});

const noAuthPaths = [...persistedPaths, ...templatePaths];

const authenticatedPaths = () => {
	const userKeys = { ...state.user };

	// Ejecting a few keys which we do not want/need persisted.
	// Don't persist `created`` as we use this to determine if user data should be fetched.
	delete userKeys.created;
	delete userKeys.updated;
	delete userKeys.email;
	delete userKeys.name;
	delete userKeys.firstName;
	delete userKeys.lastName;

	const userPaths = Object.keys(userKeys).map((k) => `user.${k}`);

	templatePaths.push('templates.permittedTypes');
	const paths = [...persistedPaths, ...templatePaths, ...userPaths];

	return paths;
};

export default {
	key: appData.key,
	paths: getApiKey() ? authenticatedPaths() : noAuthPaths,
};
